import { render, staticRenderFns } from "./InterventionView.vue?vue&type=template&id=5634fea7&scoped=true&"
import script from "./InterventionView.vue?vue&type=script&lang=js&"
export * from "./InterventionView.vue?vue&type=script&lang=js&"
import style0 from "./InterventionView.vue?vue&type=style&index=0&id=5634fea7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634fea7",
  null
  
)

export default component.exports